import { ProductSortProperty } from '../enums/productSortProperty'

export const productColumnIdSortPropertyMap: Record<string, ProductSortProperty> = {
  name: ProductSortProperty.Name,
  price: ProductSortProperty.Price,
  total: ProductSortProperty.Total,
  vatPct: ProductSortProperty.VatRate,
}
